import styled from 'styled-components';

import { Button as BaseButton } from 'components/uikit/Button/Button';

export const Button = styled(BaseButton)`
  border-radius: 16px;

  border-color: ${({ active }) => {
    let result = 'rgba(0, 0, 0, 0.1)';

    if (active) {
      result = 'transparent';
    }

    return result;
  }};

  color: ${({ active }) => {
    let result = 'var(--color-black)';

    if (active) {
      result = 'var(--color-white)';
    }

    return result;
  }};

  background-color: ${({ active }) => {
    let result = 'transparent';

    if (active) {
      result = 'var(--color-black)';
    }

    return result;
  }};
`;
